export enum UserOrderBy {
	Id = 'Id',
	DisplayName = 'DisplayName',
	Email = 'Email',
	Role = 'Role',
}
